import { render } from "./Tiers.vue?vue&type=template&id=2922c3c8&scoped=true&ts=true"
import script from "./Tiers.vue?vue&type=script&lang=ts"
export * from "./Tiers.vue?vue&type=script&lang=ts"

import "./Tiers.vue?vue&type=style&index=0&id=2922c3c8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2922c3c8"]])

export default __exports__